import React, { useContext } from 'react';
import {connect} from 'react-redux';
import { change_lang, getPermission, remove_user} from 'src/store/action';
import { withTranslation } from 'react-i18next';
import {auth,db} from 'src/config/firebase';
import { useNavigate } from 'react-router-dom';
import { englishFontFallbackMap, arabicFontFallbackMap } from 'src/screens/WhiteLabels/Templates/shared/fonts';
// material ui
import AppBar from '@mui/material/AppBar';
import withStyles from '@mui/styles/withStyles';
import { withTheme } from '@mui/styles';
import withRouter from 'src/config/withRouter';
import {  Menu } from '@mui/icons-material';
import { Badge,Divider, IconButton, SwipeableDrawer, List } from '@mui/material';
import { AlertMessage } from 'src/screens/Partners/Service/components';
import { gotoCart } from '../config/Api';
import { useTheme } from '@mui/material/styles';
import Cart from 'src/assets/images/parent/cart.svg';
import DashboardIcon from 'src/assets/images/sidemenu/parent/dashboard.svg';
import BookingIcon from 'src/assets/images/sidemenu/parent/booking.svg';
import AppointmentIcon from 'src/assets/images/sidemenu/parent/appointment.svg';
import CertificateIcon from 'src/assets/images/sidemenu/parent/certificate.svg';
import BillingIcon from 'src/assets/images/sidemenu/parent/billing.svg';
import CartIcon from 'src/assets/images/sidemenu/parent/cart.svg';
import ProfileIcon from 'src/assets/images/sidemenu/parent/profile.svg';
import LogoutIcon from 'src/assets/images/sidemenu/parent/logout.svg';
import langUKIcon from 'src/assets/images/parent/langUK.png';
import SupportIcon from 'src/assets/images/sidemenu/parent/support.png';
import langARIcon from 'src/assets/images/parent/langAR.png';
import { ParentThemeContext } from './ParentThemeContext';
import { DarkModeSwitch } from 'react-toggle-dark-mode';

const styles = theme => ({
    text:{
        color:theme.palette.text.primary,
        fontSize:'14px',
        textTransform:'uppercase'
    },

    logoDiv:{
        // width:'70px',
        // height:'70px',
        // maxWidth:'70px',
        // maxHeight:'70px',
        // borderRadius:'5px',
        // backgroundColor:'#F3F7FD',
        transition:'all 0.4s ease',
        cursor:'pointer',
        [theme.breakpoints.between('xs','lg')]: {
            // width:'46px',
            // height:'46px',
            // maxWidth:'46px',
            // maxHeight:'46px'
        },

        '&:hover':{
            opacity:0.6
        },

        '& img':{
            height:'100%',
            maxHeight:'35px',
            verticalAlign:'middle',
            boxShadow:'0px 3px 6px 0px #00000029',
        }
    },

    langSelector:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        color: '#fff',
        margin:'0px 10px',
        cursor:'pointer',
        [theme.breakpoints.between('xs','md')]: {
            display:'none'
        }
    },

    desktopLang:{
        display:'flex',
        [theme.breakpoints.between('xs','md')]: {
            display:'none'
        }
    },

    paddX:{
        padding: "0px 25px",
    },

    mobileLang:{
        display:'none !important',
        [theme.breakpoints.between('xs','md')]: {
            marginTop:'15px',
            display:'flex !important'
        }
    },

    cartIcon:{
        width:'50px',
        height:'40px',
        color:'#3D5AF1'
    },

    menuItem:{
        padding:'10px 14px',
        backgroundColor: theme.palette.background.paper,
        borderRadius:'5px',
        cursor:'pointer',
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'flex-start',
        transition: 'background 0.5s',
    },

    mobileTitle:{
        display:'none !important',
        width: 'calc(100% - 66px)',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        [theme.breakpoints.between('xs','md')]: {
            display:'block !important'
        }
    },

    menuChildItem:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        cursor:'pointer'
    },

    menuBtn:{
        display:'none',
        padding:'3px',
        [theme.breakpoints.between('xs','md')]: {
            display:'block'
        }
    },

    list: {
        width: 240,
        display:'flex',
        flexDirection:'column',
        alignItems:'flex-start',
        backgroundColor: theme.palette.background.paper
    },

    mobileList:{
        display:'flex',
        flexDirection:'column',
        justifyContent:'center',
        alignItems:'center',
        width:'calc(100% - 20px)',
        padding:'0px 10px'
    },

    mobileMenuItem:{
        textAlign: 'center',
        fontSize: '16px !important',
        color: '#000000',
        fontWeight: 400,
        lineHeight: 1.5,
        letterSpacing: '0.00938em',
    },

    logoutBtn:{
        backgroundColor:theme.palette.menu.hover,
        outline:'none',
        border:'none',
        borderRadius:'5px',
        color:'#000000',
        fontSize:'16px',
        padding:'10px 14px',
        transition: 'background 0.5s',
        cursor:'pointer',
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'flex-start',
        '&:hover':{
            backgroundColor: theme.palette.menu.hover,

            '& span':{
                color:`${theme.palette.menu.hoverText} !important`
            }
        }
    },

    customerName:{
        fontSize:'15px',
        textAlign:'center',
        color: theme.palette.text.primary,
        textTransform:'capitalize',
        fontWeight:'bold'
    },

    menuItemHover:{
        '&:hover':{
            backgroundColor: theme.palette.menu.hover,
            '& span':{
                color: `${theme.palette.menu.hoverText} !important`,
            }
        }
    },

    menuActive:{
        backgroundColor: theme.palette.menu.active,
        '& span':{
            color: theme.palette.menu.activeText,
        }
    },

    menuSpan:{
        fontSize:'9px',
        color:theme.palette.text.gray,
        textAlign:'center',
        textTransform:'capitalize',
    },

    colDiv:{
        display:'flex',
        flexDirection:'column'
    },

    cartDiv:{
        width:'50px',
        height:'40px',
        // padding: "0px 25px",
        [theme.breakpoints.between('xs','md')]: {
            width:'40px',
            height:'30px',
            // padding: "0px 5px",
        },

        '& img':{
            width:'100%',
            height:'100%'
        }
    },

    menuIcon:{
        width:'18px',
        height:'18px',
        '& img':{
            width:'100%',
            height:'100%'
        }
    },

    headerTopDiv:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        [theme.breakpoints.between('xs','md')]: {
            width:'calc(100% - 106px)'
        }
    }
});

const StyledBadge = withStyles((theme) => ({
    badge: {
        right: '35px',
        top: '5px',
        backgroundColor:'#fff',
        border: `2px solid #3D5AF1`,
        padding: '0 4px',
        color:'#3D5AF1',

        [theme.breakpoints.down('md')]: {
            right: '13px',
            top: '2px',
        }
    },
}))(Badge);

const ColorAppBar = withStyles(theme => ({
    root: {
        backgroundColor: '#fff',
        width:'100%',
        height:'55px',
        minHeight:'55px',
        position:'absolute',
        top:0,
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'space-between',
        padding:'0px 10px',
        cursor:'pointer',
        borderRadius:'7px',
        boxShadow:'0px 3px 6px 0px #00000029',
        backgroundImage: 'unset', // ❌ removes overlay (Paper-overlay)
        '--Paper-shadow': 'unset', // ❌ disables MUI box-shadow variable
        '--Paper-overlay': 'unset', // ❌ disables MUI background overlay
        [theme.breakpoints.between('xs','lg')]: {
            borderRadius:'5px',
            height:'60px',
        }
    },
}))(AppBar);

class Header extends React.Component {
    static contextType = ParentThemeContext;
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            lmsDomain:'',
            domain:'',
            urlName:'',
            openSnack:false,
            message:'',
            alertType:'',
            msj: [],
            lang:props.lang,
            menuToggle:false
        }
    }

    componentDidMount() {
        this.getMsj();
        if(this.props.user) {
            this.props.get_permission(this.props.user.id);
        };
        if(this.props.company_id) {
            this.getCompanyURL();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        this._isMounted = true;
        if(prevProps.company_id !== this.props.company_id && this._isMounted) {
            this.getCompanyURL()
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getCompanyURL = () => {
        this._isMounted = true;
        const { company_id } = this.props;
        if(company_id && this._isMounted) {
            db.ref(`Companies/${company_id}/`).on('value',(data)=> {
                const res = data.val();
                if(res) {
                    const lmsDomain = res && res.LMSDomain ? res.LMSDomain : '';
                    const domain = res && res.domain ? res.domain : '';
                    const urlName = res && res.urlName ? res.urlName : '';
                    this.setState({lmsDomain,domain,urlName});
                }
            })
        }
    }

    getMsj = () => {
        this._isMounted = true;
        var compId = this.props.company && this.props.company.companyId;

        var array = [];
        if(compId) {
            db.ref('Messages').orderByChild('companyId').equalTo(compId).on('value',(datas)=>{
                var data = datas.val()
                if(!data) {
                }
                else{
                for(var i in data) {
                    if(!data[i].read) {
                        array.push(data[i])
                    }
                }
                array.sort( function( a, b){ return a.parentId - b.parentId; } );

                for( var j=0; j<array.length-1; j++ ) {
                    if ( array[j].parentId === array[j+1].parentId && array[j].read) {
                        delete array[j];
                    }
                }
                array = array.filter( function( el ){ return (typeof el !== "undefined"); } );

                for( var k=0; k<array.length; k++ ) {
                    if (array[k].receiverId === array[k].parentId) {
                        delete array[k];
                    }
                }
                array = array.filter( function( el ){ return (typeof el !== "undefined"); } );

                for( var l=0; l<array.length-1; l++ ) {
                    if ( array[l].parentId === array[l+1].parentId) {
                        delete array[l];
                    }
                }

                array = array.filter( function( el ){ return (typeof el !== "undefined"); } );
                
                if(this._isMounted) {
                    this.setState({msj:array})
                }
            }
            })
        }
    }

    msgRedirect = path => {
        let {user,permission,company, t, history } = this.props;
        if(company && company.welcomePartner && !company.companyCompleted) {
            this.showAlert(t('no-access'),'error')
        }
        else if((user && user.companyId) && !permission.message) {
            this.showAlert(t('no-access'),'error')
        }
        else if(user && user.isParent) {
            this.showAlert(t('coming-soon'),'info')
        }
        else{
            history.push(path)
        }
    };

    update_lang = language => {
        this._isMounted = true;
        if(this._isMounted) {
            this.props.change_lang(language);
            this.props.i18n.changeLanguage(language);
            this.setState({lang:language});
            db.ref('Users/'+this.props.user.id).update({"lang":language});
        }
    };

    redirectHome = () => {
        this._isMounted = true;
        const { history } = this.props;
        if(this._isMounted) history.push('/dashboard');
    };

    redirectWebsite = () => {
        this._isMounted = true;
        const { domain, urlName } = this.state;
        const { company_id, history } = this.props;
        const host = window.location.host;
        if(company_id && this._isMounted) history.push(domain === host ? '/': urlName ? `/${urlName}` : `/company/${company_id}`);
    };

    showAlert = (message,alertType) =>{
        this.setState({alertType,message,openSnack:true});
    };

    toggleDrawerEvent = (menuToggle,event) => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
          return;
        }
    
        this.setState({ menuToggle });
    };

    render() {
        const { openSnack,alertType,message,lang,msj, menuToggle, domain, urlName } = this.state;
        const { classes, t, i18n,user,color, status, adminDemo,company, cartList, mobileTitle, history, customCls, hideCart=false, companyFonts, theme } = this.props;
        const isRTL = i18n.translator.language;
        const englishFont = englishFontFallbackMap[companyFonts?.englishFont] || "'Poppins', serif";
        const arabicFont = arabicFontFallbackMap[companyFonts?.arabicFont] || '"Cairo", sans-serif';
        const fontFamily = isRTL === 'ar' ? arabicFont : englishFont;
        const companyLogo = company?.avatar || '';
        const { mode, toggleMode } = this.context;
        console.log('mode',mode)
    return (user && user.role && !adminDemo ? "" : <ColorAppBar dir={isRTL === 'ar' ? 'rtl' :'ltr'} className={customCls || ''} style={color ? {backgroundColor:color,fontFamily:'inherit'} : {backgroundColor:theme.palette.background.paper,fontFamily:'inherit'}}>
        <div className={classes.headerTopDiv} style={{fontFamily:'inherit'}}>
            <div style={{display:'flex',flexDirection:'column',padding:'0px 10px',}}>
                <div className={classes.logoDiv} onClick={this.redirectWebsite}>
                    <img src={companyLogo} alt={company?.name || 'logo'} />
                </div>
            </div>

            <div className={classes.menuItem} style={{backgroundColor:'transparent'}}>
                <div className={classes.menuChildItem} onClick={this.redirectHome}>
                    <span className={classes.text} style={isRTL === 'ar' ? {marginRight:'15px'} : {marginLeft:'15px'}}>{t('companyPage.home')}</span>
                </div>

                {/* <div className={classes.menuChildItem} onClick={()=> (status.status && status.resolve) ? this.msgRedirect('/message') : undefined}>
                    <span className={classes.text} style={isRTL === 'ar' ? {marginRight:'15px',fontFamily} : {marginLeft:'15px',fontFamily}}>{t('white-header.msg')} <span style={isRTL === 'ar' ? {fontWeight:'bold',color:'#0F467A',marginRight:'10px'} : {fontWeight:'bold',color:'#0F467A',marginLeft:'10px'}}>{msj.length > 0 ? msj.length : ''}</span></span>
                </div> */}

                <div className={classes.menuChildItem} onClick={()=> history.push('/renew-booking')}>
                    <span className={classes.text} style={isRTL === 'ar' ? {marginRight:'15px'} : {marginLeft:'15px'}}>{t('parentDashboard.renew')}</span>
                </div>
            </div>

            <div className={`${classes.menuChildItem} ${classes.mobileTitle}`}>
                <span className={classes.text} style={isRTL === 'ar' ? {marginRight:'15px'} : {marginLeft:'15px'}}>{mobileTitle}</span>
            </div>
        </div>

        <div style={{display:'flex',flexDirection:'row',alignItems:'center',fontFamily:'inherit'}}>
            {!hideCart ?
            <StyledBadge badgeContent={cartList?.length} color="secondary" onClick={()=> gotoCart({cartList,company,history})}>
                {/* <ShoppingCart className={classes.cartIcon} /> */}
                <div className={classes.cartDiv}>
                    <img src={Cart} alt='cart' />
                </div>
            </StyledBadge>
            : null}
            
            <IconButton
                className={classes.menuBtn}
                onClick={(e)=> this.toggleDrawerEvent(true,e)}
                size="large">
                <Menu className={classes.cartIcon}/>
            </IconButton>

            <LanguageSelector 
                {...{update_lang:this.update_lang,lang,classes,customClass:`${classes.desktopLang} ${classes.paddX}`,...this.props}}
            />
            <DarkModeSwitch
                checked={theme.palette.mode === 'dark'}
                onChange={toggleMode}
                size={40}
                sunColor="#FF7043"
                moonColor="#90A4AE"
                style={{cursor:'pointer'}}
                className={classes.desktopLang}
            />
        </div>

        <SwipeableTemporaryDrawer
            companyLogo={companyLogo}
            fontFamily={fontFamily}
            company={company}
            classes={classes}
            menuToggle={menuToggle}
            domain={domain}
            urlName={urlName}
            isRTL={isRTL}
            toggleDrawerEvent={this.toggleDrawerEvent}
            redirectHome={this.redirectHome}
            redirectWebsite={this.redirectWebsite}
            update_lang={this.update_lang}
            {...{lang,...this.props}}
        />

        <AlertMessage
            {...{
                alertType,message,snackOpen:openSnack,
                closeAlert:() => this.setState({ message: '',alertType:'',openSnack:false })
            }}
        />
    </ColorAppBar>);}
};

const mapDispatchToProps = dispatch => {
    return {
        change_lang : lang => dispatch(change_lang(lang)),
        get_permission : id => dispatch(getPermission(id)),
        logout_user : () => dispatch(remove_user()),
    }
};

const mapStateToProps = state => {
    return {
        user: state.user,
        company:state.company,
        lang: state.lang,
        status: state.status,
        permission: state.permission,
        company_id: state.company_id,
        adminDemo: state.adminDemo,
        cartList: state.cartList,
        company_id: state.company_id,
        currentSession: state.uSession,
        companyFonts: state.cpFonts,
    };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(
    withStyles(styles)(
      withTheme( // 👈 injects `theme` prop
        withTranslation('common')(Header)
      )
    )
  )
);

// Drawer menu for mobile view
function SwipeableTemporaryDrawer(props) {
    const {classes, menuToggle, toggleDrawerEvent, i18n,cartList, user,company,companyLogo,fontFamily,t,redirectHome, redirectWebsite,update_lang,lang, company_id, logout_user, domain, urlName, walletValue, walletCurrency, currentSession} = props;
    const navigate = useNavigate();
    const userName = `${user?.firstName || '---'} ${user?.lastName || ''}`;
    const currentPath = window?.location?.pathname;
    const isRTL = i18n.translator.language;
    const onClickMenu = path => navigate(path);
    const theme = useTheme();
    const { mode, toggleMode } = useContext(ParentThemeContext);

    const homeEvent = (e) => {
        redirectHome();
        toggleDrawerEvent(false,e);
    };

    const menuClick = (e,path) => {
        navigate(path);
        toggleDrawerEvent(false,e);
    };

    const contactEvent = (e) => {
        window.open('https://www.selynk.com/contact-us/');
        toggleDrawerEvent(false,e);
    };

    const logout = async () => {
        const companyId = company_id.slice();
        const host = window.location.host;
        auth.signOut();
        if(currentSession) db.ref(currentSession).remove();
        navigate(domain === host ? '/': urlName ? `/${urlName}` : `/company/${companyId}`)
        logout_user();
    };

    const menuList = [
        {label:t('component.sidebar.dashboard'),path:'/dashboard',icon:DashboardIcon},
        {label:t('component.sidebar.activeBooking'),path:'/my-booking',icon:BookingIcon},
        {label:t('component.sidebar.appointement'),path:'/appointments',icon:AppointmentIcon},
        //  {label:t('component.sidebar.myCourse'),path:'',icon:CourseIcon},
        //  {label:t('component.sidebar.file'),path:'',icon:FileIcon},
        {label:t('component.sidebar.certificate'),path:'/certificates',icon:CertificateIcon},
        {label:t('parentDashboard.billing'),path:'/billing',icon:BillingIcon},
        {label:t('component.sidebar.cart'), clickEvent: cartList?.length ? () => gotoCart({cartList,company,history:null,navigate}) : null,icon:CartIcon},
        {label:t('component.sidebar.myProfile'),path:'/my-account',icon:ProfileIcon},
        {label:t('component.sidebar.support'),path:'/support',icon:SupportIcon},
        {label:t('parentDashboard.logout'),path:'',clickEvent:logout,icon:LogoutIcon,logoutBtn:true},
     ];

    const list = () => (
      <div
        className={classes.list}
        role="presentation"
        style={{fontFamily}}
        onKeyDown={(e) => toggleDrawerEvent(false,e)}
      >
        <List className={classes.mobileList}>
            <div className={classes.logoDiv} onClick={redirectWebsite} style={{margin:'20px 0px'}}>
                <img src={companyLogo} alt={company?.name || 'logo'} style={{maxHeight:'50px'}}/>
            </div>

            <div className={classes.colDiv}>
                <span style={{fontFamily}} className={classes.customerName}>{userName}</span>
                <span className={classes.menuSpan} style={{fontFamily,textTransform:'lowercase'}}>{user?.email || ''}</span>
            </div>

            <div className={classes.colDiv}>
                <span style={{fontFamily,textTransform:'uppercase',paddingTop:'30px'}} className={classes.customerName}>{walletValue ? `${walletValue} ${walletCurrency}` : '---'}</span>
                <span style={{fontFamily,marginBottom:'15px'}} className={classes.menuSpan}>{t('parentDashboard.wallet')}</span>
            </div>

            <div style={{paddingTop:'37px',width:'90%',alignSelf:'flex-start'}} className={classes.colDiv} dir={isRTL === 'ar' ? 'rtl' : 'ltr'}>
                {React.Children.toArray(menuList.map(v=> {
                    return(
                        <div style={{marginBottom:'5px'}} className={v.logoutBtn ? classes.logoutBtn : `${classes.menuItem} ${v.path === currentPath ? classes.menuActive : classes.menuItemHover}`} onClick={v.path ? ()=> onClickMenu(v.path) : v.clickEvent ? v?.clickEvent : null}>
                            <div className={classes.menuIcon} style={isRTL === 'ar' ? {paddingLeft:'11px'} : {paddingRight:'11px'}}>
                                <img src={v.icon} alt={v.label} />
                            </div>
                            <span style={{fontFamily,fontSize:'16px',color:v.path === currentPath ? theme.palette.menu.activeText : theme.palette.menu.text}}>{v.label}</span>
                        </div>
                    )
                }))}
            </div>
        </List>

        <LanguageSelector {...{update_lang,lang,customClass:classes.mobileLang,...props}}/>
        <DarkModeSwitch
            checked={theme.palette.mode === 'dark'}
            onChange={toggleMode}
            size={40}
            sunColor="#FF7043"
            moonColor="#90A4AE"
            style={{cursor:'pointer',margin:'15px 10px'}}
        />
        <Divider />
      </div>
    );
  
    return (
        <SwipeableDrawer
            anchor='right'
            open={menuToggle}
            onClose={e => toggleDrawerEvent(false,e)}
            onOpen={e => toggleDrawerEvent(true,e)}
            PaperProps={{
                sx:{
                    backgroundColor:theme.palette.background.paper,
                    backgroundImage: 'unset', // ❌ removes overlay (Paper-overlay)
                    '--Paper-shadow': 'unset', // ❌ disables MUI box-shadow variable
                    '--Paper-overlay': 'unset', // ❌ disables MUI background overlay
                }
            }}
        >
            {list()}
        </SwipeableDrawer>
    );
};

// Language select input
function LanguageSelector(props) {
    const {classes, update_lang,lang,fontFamily,t,customClass} = props;
    const inputFieldRef = React.createRef();
    const [open,setOpen] = React.useState(false);

    const handleToggle = () => {
        setOpen(!open);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleListKeyDown = (event) => {
        if (event.key === 'Tab') {
          event.preventDefault();
          setOpen(!open);
        }
    };

    const updateLang = lang => {
        update_lang(lang);
        handleClose();
    };

    return(
        <div>
        <div
            className={`${classes.langSelector} ${customClass}`}
            ref={inputFieldRef}
            aria-controls={open ? 'menu-list-grow' : undefined}
            aria-haspopup="true"
            onClick={handleToggle}
        >
            <img src={lang === 'en' ? langARIcon : langUKIcon} width="34px" height="34px" onClick={()=> updateLang(lang === 'en' ? 'ar' : 'en')} style={{borderRadius:'8px',cursor:'pointer'}} alt="language selector" />
        </div>
        </div>
    )
};